import * as React from 'react';
import { getLiveBiddingUrl } from '@/utils/urls';
import { getLocale } from '@/redux/modules/intl';
import isEqual from 'react-fast-compare';
import { isUiMobile } from '@/redux/modules/browser';
import { popupCenter } from '@/utils/popupCenter';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    children: React.ReactNode;
};

/**
 * Button that opens the bidding console window
 */
const BidConsoleOpener = ({ catalogId = 0, children = '' }: Props) => {
    const { push } = useHistory();
    const locale = useSelector((state) => getLocale(state), isEqual);
    const mobile = useSelector((state) => isUiMobile(state), isEqual);

    const localePath = locale === 'en-gb' ? `/${locale}` : '';

    const openBidConsole = React.useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            if (mobile || event.shiftKey) {
                push(getLiveBiddingUrl(catalogId));
            } else {
                popupCenter(localePath + getLiveBiddingUrl(catalogId), '', 1024, 720);
            }
        },
        [catalogId, push, localePath, mobile]
    );

    if (React.isValidElement(children)) {
        return React.cloneElement(React.Children.only(children), {
            onClick: openBidConsole,
        });
    }

    return null;
};

export default React.memo<Props>(BidConsoleOpener, isEqual);
